// extracted by mini-css-extract-plugin
module.exports = {"wrap":"app-avatar-group_wrap__2pRzk","item":"app-avatar-group_item__rG6P-","left":"app-avatar-group_left__Yr23r"};